import { NavigationGuard, Route } from "vue-router";
import * as userService from "@/service/userService";

const authGuard: NavigationGuard = async (to: Route, from: Route, next) => {

  const user = userService.getCurrentUser();
  if (user) {
    if (user.mustChangePassword && userService.isSsoLogin()) {
      next({ path: '/change-password' });
    } else {
      next();
    }
  } else {
    next({ path: '/login' });
  }
};

export default authGuard;
